import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSecurePayment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 29,
	viewBox: "0 0 36 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M33.2727 7H8.72727C7.22104 7 6 8.23122 6 9.75V26.25C6 27.7688 7.22104 29 8.72727 29H33.2727C34.779 29 36 27.7688 36 26.25V9.75C36 8.23122 34.779 7 33.2727 7Z",
			fill: "#CDCDCD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36 15H6",
			stroke: "#5F5F5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 15C6 15 12 12 12 7.5V2.25L6 0L0 2.25V7.5C0 12 6 15 6 15Z",
			fill: "#1DC483"
		})
	]
});
export default SvgSecurePayment;
